import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { GpfHistoryType } from "@type/HRM/gpf-history";

export const getGpfHistory = (() => {
  return async (data: {
    data: number | null;
  }): Promise<{ data: GpfHistoryType }> => {
    const { data: id } = data;

    const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}/${id}/gpf-loans`;

    return api.get(apiEndPoint).then((response) => {
      return {
        data: response.data.loans,
      };
    });
  };
})();
